import Products from "./components/Products";
import Banner from "./components/Banner";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Banner />
      <Products />
      <Footer />
    </div>
  );
}

export default App;
